import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const AddStateMaster = createSlice({
  name: "AddStateMaster",
  initialState: {
    isLoading: false,
    api_completed: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    add_state_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_add_state_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.api_completed = true;
      state.isSuccess = true;
      // SUCCESE(action.payload.message);
    },
    failure_api_call_add_state_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.api_completed = true;
      state.isSuccess = false;
      // FAILED(action.payload);
    },
    add_state_master_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
    add_state_master_api_complete: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default AddStateMaster.reducer;
export const {
  add_state_master,
  success_api_call_add_state_master,
  add_state_master_isSuccess,
  add_state_master_api_complete,
  failure_api_call_add_state_master,
} = AddStateMaster.actions;
